function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M0,0H16V16H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_325",
  "data-name": "Group 325",
  transform: "translate(-1655.058 -475.796)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_322",
  "data-name": "Group 322"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M1662.653,489.379a4.358,4.358,0,0,1-4.28-4.378v-5.767a.1.1,0,0,1,.1-.105h1.888a.1.1,0,0,1,.1.105v5.783a2.257,2.257,0,0,0,2.263,2.264,2.228,2.228,0,0,0,2.187-2.225v-.7a.1.1,0,0,1,.1-.105h1.888a.105.105,0,0,1,.105.105v.7A4.329,4.329,0,0,1,1662.653,489.379Z",
  fill: "#4d4d4d"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_323",
  "data-name": "Group 323",
  transform: "translate(1664.195 481.256)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1368",
  "data-name": "Rectangle 1368",
  width: 3.549,
  height: 1.704,
  rx: 0.2,
  transform: "translate(0 0)",
  fill: "#4d4d4d"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_324",
  "data-name": "Group 324",
  transform: "translate(1664.195 479.129)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_163",
  "data-name": "Path 163",
  d: "M1668.316,481.576h-3.183c-.118,0-.207-.09-.177-.182l.656-2.152a.181.181,0,0,1,.177-.112h1.872a.177.177,0,0,1,.176.112l.657,2.152C1668.522,481.486,1668.435,481.576,1668.316,481.576Z",
  transform: "translate(-1664.95 -479.129)",
  fill: "#4d4d4d"
})));

function SvgHoseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoseIcon);
export default __webpack_public_path__ + "static/media/hoseIcon.ca3bd900.svg";
export { ForwardRef as ReactComponent };